import React from "react";

import cn from "classnames";

import styles from "./TabLayout.module.scss";

interface Props {
  action?: React.ReactNode;
  children: React.ReactNode;
  hasChanges?: boolean;
  title: React.ReactNode;
}

const TabLayout: React.FC<Props> = ({ action, children, hasChanges, title }) => {
  return (
    <div className={cn(styles.container, { [styles.hasChanges]: hasChanges })}>
      <div className={styles.header}>
        <div className={styles.title}>{title}</div>
        {action}
      </div>
      {children}
    </div>
  );
};

export default TabLayout;
